import { render, staticRenderFns } from "./FinancialStatement.vue?vue&type=template&id=5b92891a"
import script from "./FinancialStatement.vue?vue&type=script&lang=ts"
export * from "./FinancialStatement.vue?vue&type=script&lang=ts"
import style0 from "./FinancialStatement.vue?vue&type=style&index=0&id=5b92891a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports